import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { formatNumber } from 'utils';

interface ItemsTableProps {
  items: Array<{
    name: string;
    unit: string;
    quantity: number;
    unitPrice: number;
    amountBeforeTax: number;
    taxRate: number;
    taxAmount: number;
    amountAfterTax: number;
  }>;
  startIndex?: number;
}

const styles = {
  table: {
    marginTop: 2,
    border: '1px solid black',
    maxHeight: 400
  },
  tableHeader: {
    flexDirection: 'row' as const,
    borderBottom: '1px solid black',
    fontSize: 9,
    minHeight: 25
  },
  tableRow: {
    flexDirection: 'row' as const,
    borderBottom: '1px dashed #ccc',
    minHeight: 20,
    alignItems: 'center' as const
  },
  tableCell: {
    padding: 4,
    fontSize: 9,
    textAlign: 'center' as const,
    borderRight: '1px solid black'
  },
  tableCellLeft: {
    padding: 4,
    fontSize: 9,
    textAlign: 'left' as const,
    borderRight: '1px solid black',
    display: 'flex' as const,
    flexDirection: 'column' as const,
    justifyContent: 'center' as const
  },
  tableHeaderCell: {
    padding: 4,
    fontSize: 9,
    textAlign: 'center' as const,
    borderRight: '1px solid black',
    display: 'flex' as const,
    flexDirection: 'column' as const,
    justifyContent: 'center' as const,
    alignItems: 'center' as const
  },
  tableHeaderCellLast: {
    padding: 4,
    fontSize: 9,
    textAlign: 'center' as const,
    display: 'flex' as const,
    flexDirection: 'column' as const,
    justifyContent: 'center' as const,
    alignItems: 'center' as const
  },
  col1: { width: '6%' },
  col2: { width: '26%' },
  col3: { width: '8%' },
  col4: { width: '12%' },
  col5: { width: '12%' },
  col6: { width: '12%' },
  col7: { width: '10%' },
  col8: { width: '14%' }
};

const ItemsTable: React.FC<ItemsTableProps> = ({ items, startIndex = 0 }) => (
  <View style={styles.table}>
    <View style={styles.tableHeader}>
      <View style={[styles.tableHeaderCell, styles.col1]}>
        <Text style={{ fontWeight: 'bold' }}>STT</Text>
        <Text style={{ fontSize: 7 }}>(No.)</Text>
      </View>
      <View style={[styles.tableHeaderCell, styles.col2]}>
        <Text style={{ fontWeight: 'bold' }}>Tên hàng hóa, dịch vụ</Text>
        <Text style={{ fontSize: 7 }}>(Description)</Text>
      </View>
      <View style={[styles.tableHeaderCell, styles.col3]}>
        <Text style={{ fontWeight: 'bold' }}>ĐVT</Text>
        <Text style={{ fontSize: 7 }}>(Unit)</Text>
      </View>
      <View style={[styles.tableHeaderCell, styles.col4]}>
        <Text style={{ fontWeight: 'bold' }}>Số lượng</Text>
        <Text style={{ fontSize: 7 }}>(Quantity)</Text>
      </View>
      <View style={[styles.tableHeaderCell, styles.col5]}>
        <Text style={{ fontWeight: 'bold' }}>Đơn giá</Text>
        <Text style={{ fontSize: 7 }}>(Unit price)</Text>
      </View>
      <View style={[styles.tableHeaderCell, styles.col6]}>
        <Text style={{ fontWeight: 'bold' }}>Thành tiền chưa thuế</Text>
        <Text style={{ fontSize: 7 }}>(Amount before VAT)</Text>
      </View>
      <View style={[styles.tableHeaderCell, styles.col7]}>
        <Text style={{ fontWeight: 'bold' }}>Thuế suất</Text>
        <Text style={{ fontSize: 7 }}>(VAT rate)</Text>
      </View>
      <View style={[styles.tableHeaderCell, styles.col8]}>
        <Text style={{ fontWeight: 'bold' }}>Tiền thuế</Text>
        <Text style={{ fontSize: 7 }}>(VAT amount)</Text>
      </View>
      <View style={[styles.tableHeaderCellLast, styles.col8]}>
        <Text style={{ fontWeight: 'bold' }}>Thành tiền sau thuế</Text>
        <Text style={{ fontSize: 7 }}>(VAT amount)</Text>
      </View>
    </View>
    {items.map((item, index) => (
      <View key={index} style={styles.tableRow}>
        <Text style={[styles.tableCell, styles.col1]}>{startIndex + index + 1}</Text>
        <Text style={[styles.tableCellLeft, styles.col2]}>{item.name}</Text>
        <Text style={[styles.tableCell, styles.col3]}>{item.unit}</Text>
        <Text style={[styles.tableCell, styles.col4]}>{item.quantity}</Text>
        <Text style={[styles.tableCell, styles.col5]}>{formatNumber(item.unitPrice)}</Text>
        <Text style={[styles.tableCell, styles.col6]}>{formatNumber(item.amountBeforeTax)}</Text>
        <Text style={[styles.tableCell, styles.col7]}>{item.taxRate}%</Text>
        <Text style={[styles.tableCell, styles.col8]}>{formatNumber(item.taxAmount)}</Text>
        <Text style={[styles.tableHeaderCellLast, styles.col8]}>
          {formatNumber(item.amountAfterTax)}
        </Text>
      </View>
    ))}
  </View>
);

export default ItemsTable;
